module.exports = __webpack_public_path__ + "img/qbert_questions_front.a65ec7a1.jpg";